export default {
  'RequestDetailsScreen.request': { en: 'REQUEST', fr: 'DEMANDE' },
};
